// === Task 32a === Storyboard view: horizontal strip of scene thumbnails +
// SceneCards + arc labels for outbound jumps. Stateless — receives the
// pre-computed analysis from FlowViewer.
import React from "react";
import SceneCard from "./SceneCard";

// Forward-compat thumbnail picker:
//  - BasicImage box → use its url
//  - HotspotImages box → use its url
//  - otherwise null (card-only)
function pickThumbnailSource(scene, boxesById, pluginToolbarsById) {
  if (!scene || !Array.isArray(scene.boxes)) return null;
  for (const boxId of scene.boxes) {
    const tb = pluginToolbarsById && pluginToolbarsById[boxId];
    if (!tb) continue;
    if (tb.pluginId === "BasicImage" && tb.state && tb.state.url) {
      return { kind: "image", ref: tb.state.url };
    }
    if (tb.pluginId === "HotspotImages" && tb.state && tb.state.url) {
      return { kind: "image", ref: tb.state.url };
    }
  }
  return null;
}

export default function StoryboardView({
  scenes,
  perScene,
  navItemsById,
  boxesById,
  pluginToolbarsById,
  viewToolbarsById,
  onJump,
}) {
  // Scene titles live in viewToolbarsById[sceneId].viewName.
  const titleOf = (sceneId) => {
    const vt = viewToolbarsById && viewToolbarsById[sceneId];
    const nav = navItemsById && navItemsById[sceneId];
    return (vt && vt.viewName) || (nav && (nav.title || nav.name)) || sceneId;
  };
  return (
    <div className="storyboard-view">
      {(scenes || []).map((sceneId) => {
        const scene = navItemsById && navItemsById[sceneId];
        if (!scene) return null;
        const thumb = pickThumbnailSource(scene, boxesById, pluginToolbarsById);
        const stats = (perScene && perScene[sceneId]) || {
          reads: [],
          writes: [],
          outboundJumps: [],
        };
        return (
          <div key={sceneId} className="storyboard-view__card-wrap">
            {thumb && thumb.kind === "image" && (
              <div
                className="storyboard-view__thumb"
                style={{ backgroundImage: `url(${thumb.ref})` }}
              />
            )}
            <SceneCard
              scene={scene}
              title={titleOf(sceneId)}
              reads={stats.reads}
              writes={stats.writes}
              outbound={stats.outboundJumps}
              onJump={onJump}
            />
            {stats.outboundJumps && stats.outboundJumps.length > 0 && (
              <div className="storyboard-view__arc">
                {stats.outboundJumps.map((j) => (
                  <span key={j} className="storyboard-view__arc-line">
                    → {j}
                  </span>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
